/**
 * Curated Google Fonts for the invitation builder (configurable list).
 * Used with WebFont Loader; load families on demand from FontPicker and
 * after loading saved canvas JSON (e.g. share preview) so Fabric text renders
 * with the correct faces.
 */
import WebFont from "webfontloader";

/** Fonts that are local / system — do not request from Google Fonts API */
export const SYSTEM_FONTS = new Set(["Georgia"]);

export const INVITATION_GOOGLE_FONTS = [
  { label: "Inter", value: "Inter" },
  { label: "Roboto", value: "Roboto" },
  { label: "Open Sans", value: "Open Sans" },
  { label: "Lato", value: "Lato" },
  { label: "Montserrat", value: "Montserrat" },
  { label: "Poppins", value: "Poppins" },
  { label: "Playfair Display", value: "Playfair Display" },
  { label: "Merriweather", value: "Merriweather" },
  { label: "Georgia (system)", value: "Georgia" },
  { label: "Source Sans 3", value: "Source Sans 3" },
  { label: "Nunito", value: "Nunito" },
  { label: "Raleway", value: "Raleway" },
  { label: "Ubuntu", value: "Ubuntu" },
  { label: "DM Sans", value: "DM Sans" },
  { label: "Plus Jakarta Sans", value: "Plus Jakarta Sans" },
  { label: "Libre Baskerville", value: "Libre Baskerville" },
  { label: "Cormorant Garamond", value: "Cormorant Garamond" },
  { label: "Great Vibes", value: "Great Vibes" },
  { label: "Pacifico", value: "Pacifico" },
  { label: "Dancing Script", value: "Dancing Script" },
  { label: "Cinzel", value: "Cinzel" },
  { label: "Quicksand", value: "Quicksand" },
  { label: "Work Sans", value: "Work Sans" },
  { label: "Fira Sans", value: "Fira Sans" },
  { label: "Rubik", value: "Rubik" },
  { label: "Outfit", value: "Outfit" },
  { label: "Sora", value: "Sora" },
  { label: "Manrope", value: "Manrope" },
  { label: "Josefin Sans", value: "Josefin Sans" },
  { label: "Crimson Text", value: "Crimson Text" },
];

function walkFabricObject(obj, families) {
  if (!obj) return;
  const ff = obj.fontFamily;
  if (typeof ff === "string" && ff.trim()) {
    families.add(ff.trim());
  }
  if (typeof obj.forEachObject === "function") {
    obj.forEachObject((child) => walkFabricObject(child, families));
  }
}

/**
 * Collect unique fontFamily values from all objects on a Fabric canvas
 * (including nested groups).
 */
export function collectFontFamiliesFromFabricCanvas(canvas) {
  if (!canvas) return [];
  const families = new Set();
  canvas.getObjects().forEach((o) => walkFabricObject(o, families));
  return [...families];
}

/**
 * Load Google Web Fonts used by the given family names, then resolve.
 * System fonts are skipped. Always resolves (even on inactive/timeout) so the
 * canvas can still render with fallback faces.
 */
export function loadInvitationGoogleFonts(families) {
  const google = [...new Set(families)]
    .filter(Boolean)
    .filter((f) => !SYSTEM_FONTS.has(f));
  if (google.length === 0) {
    return Promise.resolve();
  }
  return new Promise((resolve) => {
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      resolve();
    };
    WebFont.load({
      google: {
        families: google.map((f) => `${f}:300,400,500,600,700,italic`),
      },
      active: finish,
      inactive: finish,
      timeout: 12000,
    });
  });
}
